module.exports = __webpack_public_path__ + "img/Icon-warning.c7aacb7d.svg";